module.exports = __webpack_public_path__ + "img/img5.daf61c4e.png";